import { useEffect } from "react";
import { useQueryClient } from "react-query";

import { fetchConversations } from "../../services/chat";
import { mintTicket } from "../../services/chatSocket";
import { QUERY_KEYS } from "../../utils/config";

/**
 * ISP-9999 fe-dev-canvasjs-defer-and-messages-early-fetch — the /messages
 * conversation list wasn't slow because of any single endpoint, it was slow
 * because `dm/conversations` didn't even START firing until 3.6-7.2s after
 * navigation: `MessagesLayout` (and the `useConversations()` call inside it)
 * only exist behind a `React.lazy()` chunk, so the request queued behind
 * whatever else was mid-flight (fonts/Stripe/CanvasJS) delaying that chunk's
 * download. This component is a deliberately tiny, NON-lazy sibling mounted
 * at the route match itself (routes.js), so its effect fires in the FIRST
 * commit — independent of whether the MessagesLayout chunk has loaded yet.
 *
 * Renders nothing; only warms the react-query cache (keyed identically to
 * `useConversations()` in services/chat.js, so ConversationListPane's own
 * hook picks up this data instead of waiting on a fresh round trip) and
 * mints a WS ticket ahead of time (mirrors chatSocket.js's own mintTicket()).
 */
const MessagesRoutePrefetch = () => {
  const queryClient = useQueryClient();

  useEffect(() => {
    queryClient.prefetchInfiniteQuery(
      [QUERY_KEYS.dmConversations],
      () => fetchConversations({ offset: 0 })
    );
    mintTicket();
  }, [queryClient]);

  return null;
};

export default MessagesRoutePrefetch;
